export default [
  { title: "Riwayat Pembelian", icon: "ri-hom-4-line", link: "/purchasing-history" },
  { title: "Riwayat Pemakaian", icon: "ri-hom-4-line", link: "/sales-history" },
];
